export enum TransactionType {
    ESIM = "ESIM",
    TOPUP = "TOPUP"
}
